export default __webpack_public_path__ + "static/media/org-pulse-promo.760cc9c1.png";